import { notificationAPI } from './api';  
  
export const registerPush = async () => {  
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;  
  try {  
    const reg = await navigator.serviceWorker.register('/sw.js');  
    const { data } = await notificationAPI.getVapidKey();  
    const sub = await reg.pushManager.subscribe({  
      userVisibleOnly: true,  
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),  
    });  
    await notificationAPI.pushSubscribe(sub.toJSON());  
  } catch (e) { console.error('Push registration failed', e); }  
};  
  
function urlBase64ToUint8Array(base64String) {  
  const padding = '='.repeat((4 - base64String.length % 4) % 4);  
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');  
  const rawData = window.atob(base64);  
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));  
}
